import { render } from "./ThankYouP24.vue?vue&type=template&id=70d0a9c3"
import script from "./ThankYouP24.vue?vue&type=script&lang=js"
export * from "./ThankYouP24.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__